import React from "react";

export const useAbortController = () => {
    const controllerRef = React.useRef<AbortController | null>(null);

    React.useEffect(() => {
        return () => {
            controllerRef.current?.abort();
        }
    }, []);

    const abort = React.useCallback(() => {
        controllerRef.current?.abort();
    }, []);

    const create = React.useCallback(() => {
        controllerRef.current?.abort();
        const abortController = new AbortController();
        controllerRef.current = abortController;
        return abortController;
    }, []);

    return { create, abort, signal: controllerRef.current?.signal };
};